
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bA62P", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryPopup", () => $d0b8c8c6e36f04fe$export$e82b88b8e9b29fb6);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $bQm3c = parcelRequire("bQm3c");

var $dIouf = parcelRequire("dIouf");

var $lsxnT = parcelRequire("lsxnT");

var $jvkfi = parcelRequire("jvkfi");

var $NomII = parcelRequire("NomII");

var $alkm2 = parcelRequire("alkm2");

var $2bsYu = parcelRequire("2bsYu");
const $d0b8c8c6e36f04fe$export$e82b88b8e9b29fb6 = ({ contentId: contentId, spaceKey: spaceKey, contentType: contentType, lastModifiedDate: lastModifiedDate = '', source: source, contentPath: contentPath, setIsFeedMenuOpen: setIsFeedMenuOpen, buttonStyles: buttonStyles, onOpen: onOpen, onClose: onClose, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const [isOpen, setIsOpen] = (0, $gwFzn.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    (0, $2bsYu.useQuickSummaryQueryParamOpen)(isOpen, source, setIsOpen, contentId);
    const popupOffset = !isAdminHubAIEnabled ? [
        -10,
        8
    ] : [
        -34,
        8
    ];
    (0, $gwFzn.useEffect)(()=>{
        if (setIsFeedMenuOpen) setIsFeedMenuOpen(!!isOpen);
    }, [
        setIsFeedMenuOpen,
        isOpen
    ]);
    const onPopupClose = ()=>{
        setIsOpen(false);
        onClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'quickSummary',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'quickSummaryCloseOut',
                attributes: {
                    contentId: contentId,
                    contentType: contentType,
                    source: source
                }
            }
        }).fire();
    };
    if (contentType === 'page' || contentType === 'blogpost' || contentType === 'whiteboard') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorBoundary), {
        attribution: (0, $dIouf.Attribution).SMARTS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(Popup, {
        isOpen: isOpen,
        onClose: onPopupClose,
        placement: "bottom",
        offset: popupOffset,
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $alkm2.QuickSummaryPopupContent), {
                contentId: contentId,
                spaceKey: spaceKey,
                contentType: contentType,
                lastModifiedDate: lastModifiedDate,
                source: source,
                contentPath: contentPath,
                setIsOpen: setIsOpen
            }),
        popupComponent: (0, $NomII.CustomPopupContainer),
        shouldFlip: false,
        shouldRenderToParent: true,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jvkfi.QuickSummaryTrigger), {
                contentId: contentId,
                triggerProps: triggerProps,
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                source: source,
                buttonStyles: buttonStyles,
                onOpen: onOpen,
                onClose: onClose,
                popularFeedTimeGranularity: popularFeedTimeGranularity,
                followingFeedSortby: followingFeedSortby
            })
    }));
    return null;
};

});
parcelRegister("lsxnT", function(module, exports) {

$parcel$export(module.exports, "useChoreographerAssets", () => $be0f158b0b06806d$export$20bf42c8a29d776a);

var $gwFzn = parcelRequire("gwFzn");

var $cryCi = parcelRequire("cryCi");
const $be0f158b0b06806d$export$20bf42c8a29d776a = ()=>{
    const ctx = (0, $gwFzn.useContext)((0, $cryCi.Context));
    if (!ctx) throw new Error('ChoreographerAssetsContext not found, did you include the correct Context provider?');
    return ctx;
};

});

parcelRegister("jvkfi", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryTrigger", () => $462df38526e18a79$export$81dd2a56460c8cd9);

var $gwFzn = parcelRequire("gwFzn");

var $dIouf = parcelRequire("dIouf");

var $luv00 = parcelRequire("luv00");

var $7Uu41 = parcelRequire("7Uu41");

var $dKoe5 = parcelRequire("dKoe5");

var $2t5NR = parcelRequire("2t5NR");
const $462df38526e18a79$export$81dd2a56460c8cd9 = ({ isOpen: isOpen, setIsOpen: setIsOpen, triggerProps: triggerProps, contentId: contentId, source: source, buttonStyles: buttonStyles, onOpen: onOpen, onClose: onClose, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { isEligibleForSpotlight: isEligibleForSpotlight, stopFeatureSpotlight: stopFeatureSpotlight, spotlightEligibilityError: spotlightEligibilityError, isCurrentUserContributor: isCurrentUserContributor } = (0, $2t5NR.useSpotlightEligibilityCheck)(contentId, source);
    const renderButton = ()=>{
        if (isEligibleForSpotlight) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7Uu41.QuickSummaryButtonWithFeatureSpotlight), {
            contentId: contentId,
            triggerProps: triggerProps,
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            source: source,
            stopFeatureSpotlight: stopFeatureSpotlight
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dKoe5.QuickSummaryButton), {
            contentId: contentId,
            triggerProps: triggerProps,
            isOpen: isOpen,
            setIsOpen: setIsOpen,
            source: source,
            buttonStyles: buttonStyles,
            onOpen: onOpen,
            onClose: onClose,
            isCurrentUserContributor: isCurrentUserContributor,
            popularFeedTimeGranularity: popularFeedTimeGranularity,
            followingFeedSortby: followingFeedSortby
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-vc": "quick-summary-popup",
        ...ssrPlaceholderIdProp
    }, renderButton(), spotlightEligibilityError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dIouf.ErrorDisplay), {
        error: spotlightEligibilityError
    }));
};

});
parcelRegister("luv00", function(module, exports) {

$parcel$export(module.exports, "useSSRPlaceholderReplaceIdProp", () => $8a88875ffe13fd4c$export$30b62f74ca853d7d);

var $gwFzn = parcelRequire("gwFzn");

var $5nSna = parcelRequire("5nSna");
function $8a88875ffe13fd4c$export$30b62f74ca853d7d() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $gwFzn.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
}

});

parcelRegister("7Uu41", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryButtonWithFeatureSpotlight", () => $4bd399d6d18aae0f$export$7813fef62637e4e3);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $dKoe5 = parcelRequire("dKoe5");

var $b6dIU = parcelRequire("b6dIU");

var $bmowW = parcelRequire("bmowW");
const $4bd399d6d18aae0f$export$7813fef62637e4e3 = ({ isOpen: isOpen, setIsOpen: setIsOpen, triggerProps: triggerProps, contentId: contentId, source: source, stopFeatureSpotlight: stopFeatureSpotlight })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [spotlightActive, setSpotlightActive] = (0, $gwFzn.useState)(true);
    const endSpotlight = ()=>{
        stopFeatureSpotlight();
        setSpotlightActive(false);
    };
    (0, $gwFzn.useEffect)(()=>{
        if (spotlightActive) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'quickSummaryFeatureSpotlightOnePopup',
                attributes: {
                    contentId: contentId
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        contentId,
        spotlightActive
    ]);
    if (!spotlightActive || isOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dKoe5.QuickSummaryButton), {
        contentId: contentId,
        triggerProps: triggerProps,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        hasSeenSpotlight: false,
        source: source
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $b6dIU.SpotlightComponent), {
        contentId: contentId,
        spotlightPrompt: "featureSpotlightOne",
        endSpotlight: endSpotlight,
        spotlightBodyText: intl.formatMessage((0, $bmowW.i18n).quickSummaryFeatureSpotlightText),
        spotlightCTAText: intl.formatMessage((0, $bmowW.i18n).quickSummarySpotlightSummarizeText),
        setIsOpen: setIsOpen,
        source: source
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $dKoe5.QuickSummaryButton), {
        contentId: contentId,
        triggerProps: triggerProps,
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        hasSeenSpotlight: true,
        endSpotlight: endSpotlight,
        source: source
    }));
};

});
parcelRegister("dKoe5", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryButton", () => $3858b10110111223$export$884aa7723c662749);
/* QuickSummaryButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $4KS7f = parcelRequire("4KS7f");

var $ccHMk = parcelRequire("ccHMk");

var $3gadb = parcelRequire("3gadb");

var $inPa6 = parcelRequire("inPa6");

var $bQm3c = parcelRequire("bQm3c");

var $3DisR = parcelRequire("3DisR");

var $bmowW = parcelRequire("bmowW");
const $3858b10110111223$var$ButtonTextWrapper = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _k48p1wq8 _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $3858b10110111223$export$884aa7723c662749 = ({ isOpen: isOpen, setIsOpen: setIsOpen, triggerProps: triggerProps, contentId: contentId, hasSeenSpotlight: hasSeenSpotlight, endSpotlight: endSpotlight, source: source, buttonStyles: buttonStyles, isCurrentUserContributor: isCurrentUserContributor, onOpen: onOpen, onClose: onClose, popularFeedTimeGranularity: popularFeedTimeGranularity, followingFeedSortby: followingFeedSortby })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const summarizeText = intl.formatMessage((0, $bmowW.i18n).quickSummaryToolTipText);
    const customTheme = (currentTheme, theme)=>{
        const existingTheme = currentTheme(theme);
        const defaultStyles = {
            buttonStyles: {
                ...existingTheme.buttonStyles,
                alignItems: 'center',
                gap: "var(--ds-space-025, 2px)",
                '&:hover': {
                    backgroundColor: `${"var(--ds-background-accent-gray-subtlest, #F1F2F4)"}`
                },
                padding: buttonStyles?.padding || `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
                border: buttonStyles?.border || existingTheme.buttonStyles.border,
                borderRadius: buttonStyles?.borderRadius || existingTheme.buttonStyles.borderRadius
            }
        };
        return {
            ...existingTheme,
            ...defaultStyles
        };
    };
    const onButtonClicked = ()=>{
        if (!isOpen) {
            onOpen?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'quickSummaryIconButton',
                    objectId: contentId,
                    attributes: {
                        contentId: contentId,
                        hasSeenSpotlight: !!hasSeenSpotlight,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        isCurrentUserContributor: !!isCurrentUserContributor,
                        popularFeedTimeGranularity: popularFeedTimeGranularity,
                        followingFeedSortby: followingFeedSortby
                    }
                }
            }).fire();
        } else {
            onClose?.();
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'quickSummary',
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'quickSummaryCloseIconButton',
                    attributes: {
                        contentId: contentId,
                        hasSeenSpotlight: !!hasSeenSpotlight,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        source: source
                    }
                }
            }).fire();
        }
        setIsOpen(!isOpen);
        endSpotlight?.();
    };
    const renderButton = ()=>{
        const buttonText = buttonStyles?.buttonText ?? summarizeText;
        if (buttonStyles?.standardButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $ccHMk.default), {
            ...triggerProps,
            "aria-haspopup": "dialog",
            testId: "quick-summary-button-new",
            isSelected: isOpen,
            onClick: onButtonClicked,
            iconBefore: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3DisR.QuickSummaryIcon), {
                    label: ""
                }),
            "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
        }, buttonText);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4KS7f.default), {
            ...triggerProps,
            "aria-haspopup": "dialog" // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
            ,
            theme: customTheme,
            spacing: "none",
            testId: "quick-summary-button",
            appearance: "subtle",
            isSelected: isOpen,
            onClick: onButtonClicked,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3DisR.QuickSummaryIcon), {
                label: ""
            }),
            "aria-label": intl.formatMessage((0, $bmowW.i18n).quickSummaryLabel)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($3858b10110111223$var$ButtonTextWrapper, null, buttonText));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3gadb.default), {
        hideTooltipOnMouseDown: true,
        position: source === 'page' ? 'bottom' : 'top',
        content: summarizeText
    }, renderButton());
};

});

parcelRegister("b6dIU", function(module, exports) {

$parcel$export(module.exports, "SpotlightComponent", () => $675cfcc981459640$export$ab11813638b09f99);
/* SpotlightComponent.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $dBxQj = parcelRequire("dBxQj");

var $91xA1 = parcelRequire("91xA1");
var $1lhEF = parcelRequire("1lhEF");

var $inPa6 = parcelRequire("inPa6");

var $43KJr = parcelRequire("43KJr");

var $bmowW = parcelRequire("bmowW");
const $675cfcc981459640$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_kqswh2mm _o5724jg8",
            __cmplp.className
        ])
    });
});
const $675cfcc981459640$export$48ebf29bc7cb1dd7 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1tkeeveo _1bsb7rrr",
            __cmplp.className
        ])
    });
});
const $675cfcc981459640$export$8434332cb9a91069 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c82smr _kqswstnw _1pbykb7n _19pku2gc _1xi21i6y",
            __cmplp.className
        ])
    });
});
const $675cfcc981459640$export$9bbc9e657535eade = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1pbykb7n _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $675cfcc981459640$export$ab11813638b09f99 = ({ contentId: contentId, spotlightPrompt: spotlightPrompt, setIsOpen: setIsOpen, endSpotlight: endSpotlight, children: children, spotlightBodyText: spotlightBodyText, spotlightCTAText: spotlightCTAText })=>{
    const intl = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($43KJr)))
        ]);
    }, []);
    const onTryItClicked = ()=>{
        setIsOpen(true);
        endSpotlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'quickSummary',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'quickSummarySpotlightTryItButton',
                attributes: {
                    contentId: contentId,
                    spotlightPrompt: spotlightPrompt
                }
            }
        }).fire();
    };
    const onSpotlightCloseClicked = ()=>{
        endSpotlight();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'quickSummary',
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'quickSummarySpotlightCloseButton',
                attributes: {
                    contentId: contentId,
                    spotlightPrompt: spotlightPrompt
                }
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($675cfcc981459640$export$d0f55839b708c0a0, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($675cfcc981459640$export$9bbc9e657535eade, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $1lhEF.Pulse), {
        radius: 3
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($675cfcc981459640$export$8434332cb9a91069, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $91xA1.default), {
        key: "quick-summary-icon-spotlight",
        width: 275,
        image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement($675cfcc981459640$export$48ebf29bc7cb1dd7, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($43KJr))),
            alt: ""
        }),
        actions: [
            {
                text: spotlightCTAText,
                onClick: onTryItClicked
            },
            {
                text: intl.formatMessage((0, $bmowW.i18n).quickSummarySpotlightCloseButtonText),
                onClick: onSpotlightCloseClicked,
                appearance: 'subtle'
            }
        ]
    }, spotlightBodyText)));
};

});
parcelRegister("43KJr", function(module, exports) {
module.exports = new URL("quick_summary_spotlight.2a439c01.gif", import.meta.url).toString();

});



parcelRegister("2t5NR", function(module, exports) {

$parcel$export(module.exports, "useSpotlightEligibilityCheck", () => $6e497b2b7e7b69c0$export$b44dbe53b83fd5c4);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $j1Ss3 = parcelRequire("j1Ss3");

var $bQm3c = parcelRequire("bQm3c");

var $9oxdN = parcelRequire("9oxdN");
const $6e497b2b7e7b69c0$var$useSpotlightEligibilityCheckFeatureSpotlightUnifiedQuery = (0, $d2LG0.default)`query useSpotlightEligibilityCheckFeatureSpotlightUnifiedQuery($contentId:ID!){getSmartContentFeature(contentId:$contentId){readTime}contentContributors(id:$contentId){isCurrentUserContributor}}`;
const $6e497b2b7e7b69c0$export$b44dbe53b83fd5c4 = (contentId, source)=>{
    const { isAdminHubAIEnabled: isAdminHubAIEnabled } = (0, $bQm3c.useSessionData)();
    const [showFeatureSpotlight, stopFeatureSpotlight, featureSpotlightError] = (0, $9oxdN.useFeatureDiscovery)('quick.summary.ga.feature.spotlight.one');
    const { data: data, error: unifiedQueryError } = (0, $j1Ss3.useQuery)($6e497b2b7e7b69c0$var$useSpotlightEligibilityCheckFeatureSpotlightUnifiedQuery, {
        variables: {
            contentId: contentId
        },
        errorPolicy: 'none',
        fetchPolicy: 'network-only'
    });
    const readTime = data?.getSmartContentFeature?.readTime ?? 0;
    const isCurrentUserContributor = data?.contentContributors?.isCurrentUserContributor;
    const isEligibleForSpotlight = isAdminHubAIEnabled && showFeatureSpotlight && !featureSpotlightError && source === 'page' && readTime >= 4 && !isCurrentUserContributor;
    const spotlightEligibilityError = featureSpotlightError || unifiedQueryError;
    return {
        isEligibleForSpotlight: isEligibleForSpotlight,
        stopFeatureSpotlight: stopFeatureSpotlight,
        spotlightEligibilityError: spotlightEligibilityError,
        isCurrentUserContributor: isCurrentUserContributor
    };
};

});
parcelRegister("9oxdN", function(module, exports) {

$parcel$export(module.exports, "useFeatureDiscovery", () => $112f5732a615f62f$export$6de1a7573792d1a9);
/**
 * @graphql cc
 */ 
var $d2LG0 = parcelRequire("d2LG0");

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $7W8i8 = parcelRequire("7W8i8");

var $bQm3c = parcelRequire("bQm3c");

var $e9zUf = parcelRequire("e9zUf");
var $1UApO = parcelRequire("1UApO");

var $iyPd9 = parcelRequire("iyPd9");
const $112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery = (0, $d2LG0.default)`query useFeatureDiscoveryFeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;
const $112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation = (0, $d2LG0.default)`mutation useFeatureDiscoveryMarkFeatureDiscoveredMutation($featureKey:String!$pluginKey:String!){markFeatureDiscovered(featureKey:$featureKey pluginKey:$pluginKey){pluginKey featureKey}}`;
const $112f5732a615f62f$var$logger = (0, $7W8i8.getLogger)('useFeatureDiscovery');
const $112f5732a615f62f$export$2dd355223baa0569 = 'com.atlassian.confluence.plugins.confluence-frontend-support';
const $112f5732a615f62f$var$updateCache = (cache, { data: data })=>{
    const newMarkedFeature = data?.markFeatureDiscovered;
    const cachedFeatureData = cache.readQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery)
    });
    if (newMarkedFeature && cachedFeatureData?.featureDiscovery) cache.writeQuery({
        query: (0, $iyPd9.FeatureDiscoveryQuery),
        data: {
            featureDiscovery: cachedFeatureData.featureDiscovery.concat(newMarkedFeature)
        }
    });
};
const $112f5732a615f62f$var$getLocalOverrideValue = (featureKey)=>{
    try {
        if ((0, $e9zUf.confluenceSessionStorageInstance).getItem(`${(0, $1UApO.keys).FEATURE_DISCOVERY_OVERRIDE_PREFIX}${featureKey}`)) return true;
    } catch (e) {
        $112f5732a615f62f$var$logger.error(e);
    }
    return false;
};
const $112f5732a615f62f$var$noop = ()=>{};
const $112f5732a615f62f$export$6de1a7573792d1a9 = (featureKey, skip)=>{
    const { isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const skipFeatureDiscoveryQuery = !isLoggedIn || skip;
    const { data: data, loading: queryLoading, error: queryError } = (0, $diswb.useQuery)($112f5732a615f62f$var$useFeatureDiscoveryFeatureDiscoveryQuery, {
        skip: skipFeatureDiscoveryQuery
    });
    const [markFeatureDiscovered, { loading: mutationLoading, error: mutationError }] = (0, $diswb.useMutation)($112f5732a615f62f$var$useFeatureDiscoveryMarkFeatureDiscoveredMutation, {
        variables: {
            featureKey: featureKey,
            pluginKey: $112f5732a615f62f$export$2dd355223baa0569
        },
        update: $112f5732a615f62f$var$updateCache
    });
    const loading = queryLoading || mutationLoading;
    const error = queryError || mutationError;
    const showFeature = !loading && !error && !data?.featureDiscovery?.some((feature)=>feature?.pluginKey === $112f5732a615f62f$export$2dd355223baa0569 && feature?.featureKey === featureKey);
    const handleStop = (0, $gwFzn.useCallback)(()=>{
        if (showFeature) // error is handled in the useMutation result
        markFeatureDiscovered().catch(()=>{});
    }, [
        showFeature,
        markFeatureDiscovered
    ]);
    if (skipFeatureDiscoveryQuery) return [
        false,
        $112f5732a615f62f$var$noop,
        undefined
    ];
    // this is for dev/testing, since we cant easily remove data from the featureDiscovery array
    const forceShowFeature = showFeature || $112f5732a615f62f$var$getLocalOverrideValue(featureKey);
    return [
        forceShowFeature,
        handleStop,
        error
    ];
};

});
parcelRegister("iyPd9", function(module, exports) {

$parcel$export(module.exports, "FeatureDiscoveryQuery", () => $b4e2a77d9a5ab99b$export$b3c271f2152800f6);

var $d2LG0 = parcelRequire("d2LG0");
const $b4e2a77d9a5ab99b$export$b3c271f2152800f6 = (0, $d2LG0.default)`query FeatureDiscoveryQuery{featureDiscovery{pluginKey featureKey}}`;

});




parcelRegister("alkm2", function(module, exports) {

$parcel$export(module.exports, "QuickSummaryPopupContent", () => $002d7aa74de6041a$export$ffcfbfccccb092e2);

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $5kEnh = parcelRequire("5kEnh");

var $1ytiN = parcelRequire("1ytiN");

var $bQm3c = parcelRequire("bQm3c");

var $euL71 = parcelRequire("euL71");

var $9zqwo = parcelRequire("9zqwo");

var $brrvF = parcelRequire("brrvF");

var $6ffMd = parcelRequire("6ffMd");

var $bmowW = parcelRequire("bmowW");
const $002d7aa74de6041a$var$styles = (0, $ecnYn.xcss)({
    width: '500px'
});
const $002d7aa74de6041a$export$ffcfbfccccb092e2 = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentId: contentId, contentType: contentType, spaceKey: spaceKey, lastModifiedDate: lastModifiedDate, source: source, contentPath: contentPath, setIsOpen: setIsOpen })=>{
    const intl = (0, $dBxQj.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition, orgId: orgId } = (0, $bQm3c.useSessionData)();
    const adminLink = `https://admin.atlassian.com/o/${orgId}/atlassian-intelligence`;
    if (isAdminHubAIEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $002d7aa74de6041a$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9zqwo.QuickSummaryStreamingEntryPoint), {
        contentId: contentId,
        spaceKey: spaceKey,
        lastModifiedDate: lastModifiedDate,
        source: source,
        contentPath: contentPath,
        contentType: contentType,
        setIsOpen: setIsOpen
    }));
    if (edition !== (0, $euL71.ConfluenceEdition).PREMIUM) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $brrvF.QuickSummaryUpsell), null);
    const formatOptInMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("a", {
                href: (0, $6ffMd.ATLASSIAN_INTELLIGENCE_LEARN_MORE_LINK),
                target: "_blank"
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("br", null)
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5kEnh.default), {
        source: "quickSummary",
        product: "confluence",
        isOrgAdmin: isSiteAdmin,
        headerText: intl.formatMessage((0, $bmowW.i18n).quickSummaryOptInDialogHeaderText),
        bodyText: intl.formatMessage((0, $bmowW.i18n).quickSummaryOptInDialogBodyText, formatOptInMessageValues),
        adminBodyText: intl.formatMessage((0, $bmowW.i18n).quickSummaryAdminOptInDialogBodyText, formatOptInMessageValues),
        adminLink: adminLink,
        onAdminClose: ()=>setIsOpen(false)
    });
});

});
parcelRegister("5kEnh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad79fa1eeebb4272$export$2e2bcd8739ae039);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");
var $7p4As = parcelRequire("7p4As");

var $6f0Oj = parcelRequire("6f0Oj");
var $ecnYn = parcelRequire("ecnYn");

var $iJ2Yp = parcelRequire("iJ2Yp");

var $gVzI4 = parcelRequire("gVzI4");

var $hA5CC = parcelRequire("hA5CC");

var $4LzvV = parcelRequire("4LzvV");
const $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles = (0, $ecnYn.xcss)({
    color: 'color.text.subtlest',
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $ad79fa1eeebb4272$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink, onRender: onRender })=>{
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    (0, $gwFzn.useEffect)(()=>{
        if (onRender) onRender();
    }, [
        onRender
    ]);
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, $7UHDa.jsx)("a", {
                href: (0, $gVzI4.AI_LINK),
                target: "_blank",
                onClick: onLearnMoreClicked,
                children: s
            }),
        br: ()=>/*#__PURE__*/ (0, $7UHDa.jsx)("br", {})
    };
    const defaultHeader = formatMessage((0, $hA5CC.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $gwFzn.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($iJ2Yp)))
        ]);
    }, []);
    (0, $gwFzn.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4LzvV.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $4LzvV.OptInContainer), {
            children: [
                image ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4LzvV.ImageWrapper), {
                    children: image
                }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4LzvV.ImageWrapper), {
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($iJ2Yp))),
                        height: "96px",
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $4LzvV.ContentContainer), {
                    children: [
                        isOrgAdmin && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6f0Oj.default), {
                            xcss: $ad79fa1eeebb4272$var$VisibleTextOrgAdminStyles,
                            children: formatMessage((0, $hA5CC.messages).aiOptInAdminOnlyVisible)
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4LzvV.HeaderWrapper), {
                            children: isOrgAdmin ? orgAdminHeader : header
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4LzvV.BodyWrapper), {
                            "data-testid": "dialog-body-text",
                            children: isOrgAdmin ? orgAdminBody : body
                        }),
                        isOrgAdmin && /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $4LzvV.ButtonContainer), {
                            children: [
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                                    appearance: "subtle",
                                    onClick: onCloseClicked,
                                    testId: "admin-close-button",
                                    children: adminCloseCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminMaybeLaterButtonText)
                                }),
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7p4As.default), {
                                    appearance: "primary",
                                    onClick: onCTAClicked,
                                    href: adminLink ?? (0, $gVzI4.ADMIN_LINK),
                                    target: "_blank",
                                    testId: "admin-cta-button",
                                    children: adminCTAText ?? formatMessage((0, $hA5CC.messages).aiOptInDialogAdminGetStartedButtonText)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $ad79fa1eeebb4272$export$2e2bcd8739ae039 = $ad79fa1eeebb4272$var$AiOptIn;

});
parcelRegister("iJ2Yp", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.cf053e66.svg", import.meta.url).toString();

});

parcelRegister("gVzI4", function(module, exports) {

$parcel$export(module.exports, "AI_LINK", () => $30266e962d22c479$export$550fac1a4ec3d365);
$parcel$export(module.exports, "ADMIN_LINK", () => $30266e962d22c479$export$bae9a077d7ed5dfe);
const $30266e962d22c479$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $30266e962d22c479$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

});

parcelRegister("hA5CC", function(module, exports) {

$parcel$export(module.exports, "messages", () => $55820977c77a8e8c$export$defe85febe8b728c);

var $2nPZH = parcelRequire("2nPZH");
const $55820977c77a8e8c$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    /**
   * Messages for the AI Global Opt-in component
   */ aiOptInDialogHeaderText: {
        id: "ai-opt-in.dialog.header.text",
        defaultMessage: "Work smarter, not harder"
    },
    aiOptInDialogBodyText: {
        id: "ai-opt-in.dialog.body.text",
        defaultMessage: "Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration."
    },
    aiOptInDialogLearnMoreLinkText: {
        id: "ai-opt-in.dialog.learn-more.link.text",
        defaultMessage: "Learn more about Atlassian Intelligence"
    },
    aiOptInDialogAdminBodyText: {
        id: "ai-opt-in.dialog.admin.body.text",
        defaultMessage: "Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration."
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: "ai-opt-in.dialog.admin.maybe-later.button.text",
        defaultMessage: "Maybe later"
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: "ai-opt-in.dialog.admin.get-started.button.text",
        defaultMessage: "Get started"
    },
    aiOptInBannerBodyText: {
        id: "ai-opt-in.banner.body.text",
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it."
    },
    aiOptInBannerLearnMoreText: {
        id: "ai-opt-in.banner.learn.more.text",
        defaultMessage: "Learn more"
    },
    aiOptInAdminBannerBodyText: {
        id: "ai-opt-in.banner.admin.body.text",
        defaultMessage: "Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration."
    },
    aiOptInAdminOnlyVisible: {
        id: "ai-opt-in.admin.only.visible.text",
        defaultMessage: "This message is only visible to org admins."
    }
});

});

parcelRegister("4LzvV", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $3161983b4d5922a4$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $3161983b4d5922a4$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $3161983b4d5922a4$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $3161983b4d5922a4$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $3161983b4d5922a4$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $3161983b4d5922a4$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $3161983b4d5922a4$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
var $iAWao = parcelRequire("iAWao");
const $3161983b4d5922a4$export$24c280970213bb11 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $iAWao.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1reo15vq _18m915vq _2rko14y2 _11q71lxv _16qs1cd0 _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _kqswh2mm",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3161983b4d5922a4$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_2rko1k7a _1e0c1txw _1biu1k7a _1jpx1dfr _mezj1osq",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulpu2gc _1e0c1txw _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb _2lx21bp4 _1wpz1fhb _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_11c8nbxd",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$14966827497f4695 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11c82smr",
            __cmplp.className
        ])
    });
});
const $3161983b4d5922a4$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_zulp1b66 _1e0c1txw _1bsb1osq _19pku2gc _1bahesu3",
            __cmplp.className
        ])
    });
});

});



parcelRegister("2bsYu", function(module, exports) {

$parcel$export(module.exports, "useQuickSummaryQueryParamOpen", () => $ff45dc1c950c6fe5$export$1e7c1e0a8136f3b6);

var $gwFzn = parcelRequire("gwFzn");

var $inPa6 = parcelRequire("inPa6");

var $dPJCf = parcelRequire("dPJCf");

var $bQm3c = parcelRequire("bQm3c");
const $ff45dc1c950c6fe5$var$useOpenQuickSummaryParam = (0, $dPJCf.createSingleQueryParamHook)('openQuickSummary');
const $ff45dc1c950c6fe5$export$1e7c1e0a8136f3b6 = (isOpen, source, setIsOpen, contentId)=>{
    const [hasSeen, setHasSeen] = (0, $gwFzn.useState)(false);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, edition: edition } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isOpenQuickSummaryQueryParamValid = $ff45dc1c950c6fe5$var$useOpenQuickSummaryParam() === 'true';
    (0, $gwFzn.useEffect)(()=>{
        if (!isOpen && source === 'page' && isOpenQuickSummaryQueryParamValid && !hasSeen) {
            setIsOpen(true);
            setHasSeen(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    source: source,
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'quickSummaryIconButton',
                    objectId: contentId,
                    attributes: {
                        contentId: contentId,
                        hasSeenSpotlight: false,
                        isAIOptedIn: isAdminHubAIEnabled,
                        edition: edition,
                        isFromQueryParam: true
                    }
                }
            }).fire();
        }
    }, [
        isOpen,
        setIsOpen,
        isOpenQuickSummaryQueryParamValid,
        hasSeen,
        setHasSeen,
        source,
        contentId,
        createAnalyticsEvent,
        edition,
        isAdminHubAIEnabled
    ]);
};

});



//# sourceMappingURL=QuickSummaryPopup.5422cfb6.js.map
